module.exports = __webpack_public_path__ + "img/serve3.1ef016fc.jpg";